export const fxContainerTestId = 'fx-calculator';
export const fxSenderInputTestId = 'sender-input';
export const fxVendorInputTestId = 'vendor-input';
export const fxInputTestId = 'calculator-input';
export const fxLoadingSpinnerTestId = 'loading-spinner';
